import { Injectable } from '@angular/core';

import { LocalStorageService } from '@recruitee/common';
import { EMOJIS, EmojiItem, emojiItemToSymbolItem, SymbolItem } from '@recruitee/symbol-data';

@Injectable({
  providedIn: 'root',
})
export class EmojiRecentlyUsedService {
  public readonly usedEmojisLimit = 27;
  private readonly EMOJI_RECENTLY_USED_KEY = `emoji-recently-used`;

  constructor(private localStorage: LocalStorageService) {}

  public saveEmoji(emojiCode: string): void {
    let newUsedEmojiCodes: string[];
    if (this.isUsed(emojiCode)) {
      newUsedEmojiCodes = this.moveEmojiToStart(emojiCode);
    } else {
      newUsedEmojiCodes = this.getUsedEmojiCodes();
      newUsedEmojiCodes.unshift(emojiCode);
    }

    this.saveNewUsedEmojiCodes(newUsedEmojiCodes);
  }

  public getUsedEmojis(): Array<SymbolItem<EmojiItem>> {
    const usedEmojiCodes = this.getUsedEmojiCodes().slice(0, this.usedEmojisLimit);
    const usedEmojis: Array<SymbolItem<EmojiItem>> = [];
    usedEmojiCodes.forEach(emojiCode => {
      const emoji = EMOJIS.find(emoji => emoji.unified === emojiCode);
      if (emoji) usedEmojis.push(emojiItemToSymbolItem(emoji));
    });
    return usedEmojis;
  }

  private getUsedEmojiCodes(): string[] {
    return <string[]>this.localStorage.get(this.EMOJI_RECENTLY_USED_KEY, []);
  }

  private isUsed(emojiCode: string): boolean {
    const usedEmojis = this.getUsedEmojiCodes();
    return usedEmojis.includes(emojiCode);
  }

  private saveNewUsedEmojiCodes(emojiCodes: string[]): void {
    const newUsedEmojiCodes = emojiCodes.slice(0, this.usedEmojisLimit);
    this.localStorage.set(this.EMOJI_RECENTLY_USED_KEY, newUsedEmojiCodes);
  }

  private moveEmojiToStart(emojiCode: string): string[] {
    const usedEmojiCodes = this.getUsedEmojiCodes();
    const emojiIndex = usedEmojiCodes.findIndex(code => code === emojiCode);
    usedEmojiCodes.splice(emojiIndex, 1);
    usedEmojiCodes.unshift(emojiCode);
    return usedEmojiCodes;
  }
}
